import React from 'react';
import { motion } from 'framer-motion';
import '../../style/legacy/Products.css'; // CSS for styling the cards
import GenericResearchNav from '../Research/GenericResearchNav';
import NewFooter from '../../common/NewFooter';
import SEO from '../../common/SEO';

import img1 from '../../../assets/images/products/Natural Fiber/Areca Fiber Mat.jpg';
import img2 from '../../../assets/images/products/Natural Fiber/Bamboo Fiber Mat.jpg';
import img3 from '../../../assets/images/products/Natural Fiber/Banana Fiber Mat.jpg';
import img4 from '../../../assets/images/products/Natural Fiber/Coir Fiber Mat.jpg';
import img5 from '../../../assets/images/products/Natural Fiber/Flax Fiber Mat.jpg';
import img6 from '../../../assets/images/products/Natural Fiber/Kenaf Fiber Mat.jpg';
import img7 from '../../../assets/images/products/Natural Fiber/Nano TItania.jpg';
import img8 from '../../../assets/images/products/Natural Fiber/Natural Jute Mat.jpg';
import img9 from '../../../assets/images/products/Natural Fiber/Ramie Fiber Mat.jpg';
import img10 from '../../../assets/images/products/Natural Fiber/Sisal Fiber MAt.jpg';
import img11 from '../../../assets/images/products/Natural Fiber/Sun hemp Fiber Mat.jpg';
import img12 from '../../../assets/images/products/Natural Fiber/White Fabric Pineapple Fiber Mat.jpg';

const products = [
  {
    title: 'Areca Fiber Mat',
    img: img1,
  },
  {
    title: 'Bamboo Fiber Mat',
    img: img2,
  },
  {
    title: 'Banana Fiber Mat',
    img: img3,
  },
  {
    title: 'Coir Fiber Mat',
    category: 'Civil Laboratory Equipment',
    img: img4,
  },
  {
    title: 'Flax Fiber Mat',
    category: 'Civil Laboratory Equipment',
    img: img5,
  },
  {
    title: 'Kenaf Fiber Mat',
    category: 'Civil Laboratory Equipment',
    img: img6,
  },
  {
    title: 'Nano TItania',
    category: 'Civil Laboratory Equipment',
    img: img7,
  },
  {
    title: 'Natural Jute Mat',
    category: 'Civil Laboratory Equipment',
    img: img8,
  },
  {
    title: 'Ramie Fiber Mat',
    category: 'Civil Laboratory Equipment',
    img: img9,
  },
  {
    title: 'Sisal Fiber MAt',
    category: 'Civil Laboratory Equipment',
    img: img10,
  },
  {
    title: 'Sun hemp Fiber Mat',
    category: 'Civil Laboratory Equipment',
    img: img11,
  },
  {
    title: 'White Fabric Pineapple Fiber Mat',
    category: 'Civil Laboratory Equipment',
    img: img12,
  },
];

const cardVariants = {
  hidden: { opacity: 0, y: 100 },
  visible: i => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.2, // Stagger animation for each card
      duration: 0.5,
    },
  }),
};

const Products = () => {
  const productSchema = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'Natural Fiber Research Products & Lab Equipment',
    itemListElement: products.map((product, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@type': 'Product',
        name: product.title,
        description: `Research grade ${product.title} for experimental testing and composite material development by Assurance Education Group Bhopal.`,
        brand: { '@type': 'Brand', name: 'AEG Research' }
      }
    }))
  };

  return (
    <>
      <SEO 
        title="Research Paper Design and Publication | SCI Scopus Products Bhopal"
        description="Explore Research Paper design and publication solutions, IEEE paper writing, SCI paper writing bhopal, Scopus paper writing, and specialized research equipment by Assurance Education Group in Bhopal."
        keywords={[
          "Research Paper design and publication",
          "Research paper writing and publication",
          "SCI paper writing bhopal",
          "Scopus paper writing bhopal",
          "IEEE paper writing",
          "Paper Writing Bhopal",
          "Scientific Research"
        ]}
        canonicalPath="/products"
        schemaData={productSchema}
        breadcrumbs={[
          { name: 'Home', path: '/' },
          { name: 'Products', path: '/products' }
        ]}
      />
      <GenericResearchNav />
      <div className='products-container pt-24 min-h-screen'>
        <h1 className='heading pt-24 font-bold'>Our Products &ndash; Natural Fiber Mats &amp; Lab Equipment</h1>
        <div className='grid-container'>
          {products.map((product, index) => (
            <motion.div
              className='product-card'
              key={index}
              custom={index}
              initial='hidden'
              animate='visible'
              variants={cardVariants}
            >
              <img
                src={product.img}
                alt={`${product.title} - Natural Fiber Research Product by AEG Research Bhopal`}
                className='product-image'
              />
              <div className='product-info'>
                <h3>{product.title}</h3>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <NewFooter />
    </>
  );
};

export default Products;
